import React from "react";
import { App } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { Route, Routes, Navigate } from "react-router-dom";
import { CentralHomeScreen } from "../screens";
import { CentralStats } from "../screens/CentralStats";
import CentralSupport from "../screens/CentralSupport";
import CentralGuide from "../screens/CentralGuide";
import { Col } from "@neumetric/blueprint-lib/components";
import { NMHomeScreen, NMLoginScreen, NMPageNotFoundPage } from "@neumetric/blueprint-lib/pages";

const DOMAIN = process.env.REACT_APP_MAIN_DOMAIN;
const ENVIRNOMENT_ID = process.env.REACT_APP_ENVIRNOMENT_ID;
const ENVIRNOMENT_TITLE = process.env.REACT_APP_ENVIRNOMENT_TITLE;
const ModuleID = "central";
const Environment = { id: ENVIRNOMENT_ID, title: ENVIRNOMENT_TITLE };

const CentralRouter = () => {
  return (
    <CentralHomeScreen>
      <Routes>
        <Route path="O" element={<CentralStats />} />
        <Route path="G" element={<CentralGuide />} />
        <Route path="S" element={<CentralSupport />} />
        <Route path="" element={<Navigate replace to="O" />} />
      </Routes>
    </CentralHomeScreen>
  );
};

const MainRouter = () => {
  const context = App.useApp();
  const location = useLocation();
  const isStandalone = location.search.includes("standalone=true");
  return (
    <Col className={`w-100 h-100 overflow-hide ${isStandalone ? "standalone-view" : ""}`}>
      <NMHomeScreen hideHeader={isStandalone} appContext={context} environment={Environment} domain={DOMAIN} moduleId={ModuleID}>
        <Routes>
          <Route path="/" element={<Navigate replace to="/C" />} />
          <Route path="/C/*" element={<CentralRouter />} />
          <Route path="*" element={<Navigate replace to="/page-not-found" />} />
        </Routes>
      </NMHomeScreen>
    </Col>
  );
};

const LogInWrapper = () => {
  const navigate = useNavigate();
  return <NMLoginScreen onNavigate={(path) => navigate(path)} moduleId={ModuleID} environment={Environment} />;
};

function AppRouter() {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route path="/login" element={<LogInWrapper />} exact />
      <Route
        path="/page-not-found"
        element={<NMPageNotFoundPage domain={DOMAIN} onNavigate={(path) => navigate(path)} />}
        exact
      />
      <Route path="/*" element={<MainRouter />} />
    </Routes>
  );
}

export default AppRouter;
